import * as React from 'react';
import { Box, Text } from '@chakra-ui/react';

function Footer(): JSX.Element {
  return (
    <Box p={8}>
      <Text opacity={0.25}>Footer is also in progress, lol</Text>
    </Box>
  );
}

export default Footer as React.FC;
